import React, { Component } from 'react'
import { connect } from 'react-redux'
import Moment from 'moment'

import { doc } from 'selectors/common'
import { dirtyRead } from 'selectors/common'
import { tasks } from 'selectors/entities'
import { projectTasks, openTasksByProjectID } from 'selectors/tasks'

import Section from 'components/Section'
import AddButton from 'components/AddButton'
import TaskList from './List'
import dataActions from 'actions/dataActions'
import Divider from 'material-ui/Divider'

let select = dirtyRead(
	(state, props) => {
		return ({
			tasks: projectTasks(state, props)
		  , openTasks: openTasksByProjectID(state)
			, project: doc(state, props.projectID)
			, login: state.session
		})
	}
)

export class Tasks extends Component{
	render(){
		let { props } = this
		let projectID = props.projectID
		let count = props.openTasks && props.openTasks[projectID] && props.openTasks[projectID].length? props.openTasks[projectID].length:"0"
		return(
				<Section
					id="project/tasks"
					title="Tasks"
					badge={count}
					rightButton={<AddButton object={{
							taskContent: ''
						, projectID: props.project._id
						, propertyID: props.project.propertyID
						, accepted: ""
						, priority: ""
						, done : false
						, status: "Open"
						, urgent: ""
						, note: ""
						, schedule: {
							curStart: new Date()
							, curDue: new Date(Moment(new Date()).add(1, 'days'))
							, curDuration: 1
							, curStrictStart: false
							, curStrictDue: false
						}
						, managerID : props.project.managerID
						, dependencies : []
						, comments: []
						, type: "task"
						, history:[{
							userID: props.login.userID
							, auto: true, body: 'Create task'
							, date: new Date().valueOf()
							, value: ''
						}]
					}} />}
				>
					<div
						style={{
							width: "100%"
						}}
						speed={0.8}
						className="area"
						contentClassName="content"
						horizontal={false}
						verticalScrollbarStyle={{
							width: "16px"
						  , borderRadius: "13px"
						  , marginLeft: "1px"
						  , backgroundImage: "url(/assets/manager/img/bar.png)"
						  , backgroundSize: "100%"
						  , backgroundRepeat: "no-repeat"
						  , backgroundColor: "#f5f6f5"
						  , backgroundPosition: "center"
						}}
						minScrollSize={30}
						verticalContainerStyle={{
							width: "18px"
						  , backgroundColor: "#cdcdcd"
						  , opacity: "1"
						}}
						// ref="right-panel"
					>
						<div>
							<div className="logical-block" style={{clear: "both", padding: '0'}}>
								<TaskList projectID={projectID} />
							</div>
						</div>
					</div>
				</Section>
		)
	}
}

export default connect(select, dataActions)(Tasks)



// WEBPACK FOOTER //
// ./src/routes/manager/projectForm/tasks/index.js